import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * The Recycle Bin.
 *
 * A singleton, because there is only one bin and XP focused the window you
 * already had rather than opening a second view of the same shell folder.
 *
 * It takes no args: what it shows comes from `useRecycleStore`, not from a
 * path, so re-opening it never needs to re-arm anything.
 */
export const recycleBinApp: AppManifest = {
  id: 'recyclebin',
  name: 'Recycle Bin',
  icon: '/assets/icons/recycle-bin.svg',
  component: lazy(() => import('./RecycleBin')),

  defaultSize: { w: 640, h: 460 },
  minSize: { w: 400, h: 300 },
  resizable: true,
  maximizable: true,
  singleton: true,

  // A shell folder rather than a program: XP put it on the desktop and in
  // no menu at all, which is also why it keeps its `group` for nothing.
  showInAllPrograms: false,

  group: 'System',
  titleFor: () => 'Recycle Bin',
};
